<template>
  <div class="row">
    <div class="form-group col-sm-12 px-0">
      <div
        v-for="(file, index) in filesList" :key="index"
        class="d-flex col-sm-12 mb-2">
        <div class="col-9 px-0 styleFileName">
          <u style="cursor: pointer;" @click="downloadFile(file)">{{file.Name}}</u>
        </div>
        <div class="col-3 px-0 text-right file-option-button">
          <span v-if="canDelete" class="btnDelete" style="cursor:pointer" @click="deleteFile(index)"><u>{{$t('common.rm_label')}}</u></span>
          <label v-else-if="canReplace" class="LMSGcolor btnAdd" style="cursor:pointer" :for="'file_reuploads-' + id">{{ $t('iframe_page.replace') }}</label>
        </div>
      </div>
    </div>
    <div v-if="canAdd" class="col-sm-12">
      <label class="float-right btnAdd" style="cursor:pointer" :for="'file_uploads-' + id"><u>{{$t('common.add_label')}}</u></label>
    </div>
    <input class="d-none" :id="'file_uploads-' + id" ref="file" type="file" accept=".jpeg,.jpg,.png,.pdf" :multiple="multiple" @change="addFileToList()" :key="'add' + fileInputKey"/>
    <input class="d-none" :id="'file_reuploads-' + id" ref="file_re" type="file" accept=".jpeg,.jpg,.png,.pdf" :multiple="multiple" @change="changeFileInList()" :key="'replace' + fileInputKey"/>
    <div v-if="hasError" class="col-sm-12 error-validate-msg text-justify">
      {{ errorMsg }}
    </div>
  </div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'

export default {
  name: 'multipleDocumentsUpload',
  props: {
    canAdd: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    canReplace: {
      type: Boolean,
      default: false
    },
    errorMsg: {
      type: String,
      default: ''
    },
    hasError: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    filesList: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  data: function () {
    return {
      fileInputKey: 0
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    addFileToList () {
      // console.log('addFileToList', this.$refs.file)
      if (this.$refs.file && this.$refs.file.files && this.$refs.file.files.length) {
        this.parseFileList(this.$refs.file.files, 'add')
        // method to reset input containing a FileList type
        this.fileInputKey = this.fileInputKey === 0 ? 1 : 0
      }
    },
    changeFileInList () {
      // console.log('changeFileInList', this.$refs.file_re.files)
      if (this.$refs.file_re && this.$refs.file_re.files && this.$refs.file_re.files.length) {
        this.parseFileList(this.$refs.file_re.files, 'replace')
        // method to reset input containing a FileList type
        this.fileInputKey = this.fileInputKey === 0 ? 1 : 0
        this.msgUpload()
      }
    },
    deleteFile (index) {
      this.filesList.splice(index, 1)
    },
    downloadFile (file) {
      // handling IE11 download since <a> tag doesn't handle download attribute
      if (navigator.msSaveOrOpenBlob) {
        // this function is deprecated on other navigators
        const blob = new Blob([atob(file.Data)])
        navigator.msSaveOrOpenBlob(blob, file.Name)
      } else {
        // on not deprecated navigators
        let link = document.createElement('a')
        link.download = file.Name
        if (!file.Data) {
          this.$engine.services.businessDocuments.getDocumentDetails(file.IdDocument)
          .then(response => {
            if (response.status === 200) {
              link.href = response.data.Documents[0].Data
              let evt = document.createEvent('MouseEvents')
              evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
              link.dispatchEvent(evt)
            }
          })
          .catch(error => {
            errorMessageAlert(error, this)
          })
        } else {
          link.href = file.Data
          let evt = document.createEvent('MouseEvents')
          evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
          link.dispatchEvent(evt)
        }
      }
    },
    msgUpload (file) {
      this.$emit('fileUploaded', file)
    },
    parseFileList (filesList, action) {
      let that = this
      Object.keys(filesList).forEach((index) => {
        let file = filesList[index]
        let filename = file.name
        let fd = new FileReader()
        fd.onload = (event) => {
          let fileData = event.target.result
          if (fileData && !that.filesList.map(elem => elem.name).includes(filename)) {
            if (that.multiple && action === 'add') {
              that.filesList.push({Name: filename, Data: fileData})
              that.filesList = that.filesList
            } else {
              let tmp = {
                Name: filename,
                Data: fileData,
                idDocument: that.filesList.length ? that.filesList[0].idDocument : undefined
              }
              that.filesList = [tmp]
            }
            if (this.hasError) {
              this.resetError()
            }
          }
        }
        fd.readAsDataURL(file)
      })
    },
    resetError () {
      this.$emit('resetError')
    }
  }
}
</script>
<style scoped>
.btnAdd {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 15px;
  text-decoration-line: underline;
  color: #49A0A2;
}
.styleFileName {
  font-style: normal;
  font-weight: 300;
  font-size: 11px;
  line-height: 13px;
  text-decoration-line: underline;
  color: #1B1918;
}
.file-option-button {
  line-height: 13px;
}
.btnDelete {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  text-decoration-line: underline;
  color: #959595;
}
</style>



// WEBPACK FOOTER //
// multipleDocumentsUpload.vue?0122cb7b